import { BadgeCheckIcon } from "lucide-react"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

const SuccessPage = () => {
  return (
    <div className="mx-auto md:w-10/12 lg:w-8/12 xl:w-6/12">
      <Card className="shadow-lg">
        <CardHeader className="">
          <h1 className="text-center text-2xl">
            Documento firmado exitosamente
          </h1>
        </CardHeader>

        <CardContent className="flex flex-col items-center gap-6">
          <BadgeCheckIcon size={92} className="text-primary" />

          <p>Gracias por utilizar Firme</p>

          <p>
            Una vez que firmen todas las personas te llegará a tu correo la
            versión final firmada.
            <br />
            <br />
            Por cualquier información adicional, te recomendamos comunicarte con
            la persona que te invitó a firmar o escribirnos directamente a{" "}
            <strong>ayuda@firme.app</strong>.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}

export { SuccessPage }
